export default __webpack_public_path__ + "static/media/beavers-characters.b60608fc.png";